<ng-container *transloco="let t">
    <div class="admin-card">
        <div class="d-flex justify-content-between align-items-start">
            <div>
                <app-filter-panel [groups]="filterGroups"
                                  (filterChange)="onFilterChange($event)" />
            </div>
            <div class="pt-2">
                <div class="duplicates-button" (click)="openDuplicatesModal()">
                    <div class="holder">
                        <i class="bi bi-people-fill icon"></i>
                        @if (duplicates.length) {
                        <div class="count">
                            {{duplicates.length}}
                            </div>
                            }
                            </div>
                        </div>
                        </div>
                        </div>

                            @if (competitors?.length){
                        <div class="table-responsive competitor-table">
                            <app-sortable-table cssClass="table dark-header table-last-row-no-border" infinite-scroll
                            [infiniteScrollDistance]="1" (scrolled)="loadMore()" (onSort)="onSort($event)" [handleSorting]="false"
                            [items]="competitors">
                            <thead>
                            <tr>
                            <th class="id-column-width" [sortBy]="['id']">{{t("app.common.id")}}</th>
                        <th class="full-name-width" [sortBy]="['firstName', 'lastName', 'teamName']">{{ t("app.common.first.name") }}</th>
                            <th [sortBy]="['country']">{{ t("app.common.country") }}</th>
                            <th class="gender-col-width" [sortBy]="['sex']">{{ t("app.common.gender") }}</th>
                            <th [sortBy]="['categoryItemLabel']">{{ t("app.common.category") }}</th>
                            <th [sortBy]="['matchStatus']">{{ t("league.competitor.match.status") }}</th>
                            <th class="more-col-th more-column-width"></th>
                            </tr>
                            </thead>
                            <tr app-table-header-separator></tr>
                            <tbody>
                            @for(competitor of competitors; track competitor.id){
                            <tr>
                                <td class="center-align">{{ competitor.id ?? '-'}}</td>
                                <td class="center-align">
                                    {{ competitor.isTeam ? (competitor.teamName ?? '-') : ((competitor.firstName ?? '') + ' ' + (competitor.lastName ?? '')) }}
                                </td>
                                <td class="center-align">{{ (competitor.country | country)}}</td>
                                <td class="center-align">
                                    @if (competitor.sex) {
                                    <div class="badge-holder__badge" [ngClass]="
                                    {'gender-badge-man': (competitor.sex !== 2),
                                    'gender-badge-women': competitor.sex === 2}">
            <span class="text-uppercase">{{t('app.common.gender.short.' + competitor.sex)}}</span>
            </div>
                                    }
                                </td>
                                <td class="center-align">{{ competitor.categoryItemLabel ?? '-'}}</td>
                                <td class="center-align">
                                    @if (competitor.matchStatus) {
                                    <div class="status-badge"
                                      [class.green]="competitor.matchStatus === MatchStatus.FULL_MATCH"
                                      [class.blue]="competitor.matchStatus === MatchStatus.MERGED"
                                      [class.gray]="competitor.matchStatus === MatchStatus.DUPLICATE"
                                      [class.gray-bck-blue-clr]="competitor.matchStatus === MatchStatus.MERGED_DUPLICATE"
                                      >
                                      <span class="fw-500">
                                    {{ t('league.competitor.match.status.' + competitor.matchStatus) | uppercase}}
                                    </span>
                                   </div>
                                    }
                                </td>
                                <td class="more-col-td">
                                    <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                <span class="menu-icon" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                </span>
                                        <ul ngbDropdownMenu>
                                            <li ngbDropdownItem
                                                (click)="openCompetitorDetails(competitor)">
                                                {{ t("app.common.details") }}
                                            </li>
                                            @if (competitor.matchStatus === MatchStatus.MERGED || competitor.matchStatus === MatchStatus.MERGED_DUPLICATE) {
                                            <li ngbDropdownItem
                                                (click)="openMatchDetails(competitor)">
                                            {{ t("league.competitors.match.details") }}
                                            </li>
                                            }
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            }
                            </tbody>
                            </app-sortable-table>
                            </div>
                            }
                        @else {
                        <div class="my-3">
                                <app-empty-state-admin />
                        </div>
                        }
                    </div>

</ng-container>
